export const washingCount = {
  title: '洗濯回数',
}
